import React, { createContext, useState, ReactElement, FC, useRef, useEffect } from "react";

type AuthType = {
  username: string,
  role: "Moderator" | "SuperUser" | "DefaultUser"
}

type AuthContextType = {
  auth?: AuthType,
  setAuth?: React.Dispatch<React.SetStateAction<AuthType | undefined>>
  roleAccess?: (roles: string[]) => boolean,
  accessToken: React.MutableRefObject<string | null>,
  webSocketToken: React.MutableRefObject<string | null>,
  updateAccessToken: (newToken: string | null) => void,
  updateWebSocketToken: (newToken: string | null) => void,
}

type Props = {
  children: ReactElement
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const AuthProvider: FC<Props> = ({ children }) => {
  const [auth, setAuth] = useState<AuthType>();

  const accessToken = useRef<string | null>(null);
  const webSocketToken = useRef<string | null>(null);

  const updateAccessToken = (newToken: string | null) => {
    accessToken.current = newToken
  }

  const updateWebSocketToken = (newToken: string | null) => {
    webSocketToken.current = newToken
  }

  const roleAccess = (roles: string[]) => {
    if (!roles?.length) return true
    if (!auth) return false
    return roles.includes(auth.role)
  }

  return (
    <AuthContext.Provider value={{ auth, setAuth, roleAccess, accessToken, webSocketToken, updateAccessToken, updateWebSocketToken }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;
